import {axiosApiInstance} from '../axios';

export const editComment = (id , formData) =>{
    return axiosApiInstance.put(`/admin/comments/${id}` , formData);
}

